/**
 * Centralised, type-safe access to build-time environment configuration.
 *
 * Create React App only exposes variables prefixed with `REACT_APP_` to the
 * browser bundle, so every value is read through that namespace and given a
 * sensible default that matches the backend's local development settings
 * (API mounted at `/api/v1` on port 4000 — see factory-backend/.env).
 */

const DEFAULT_API_URL = "http://localhost:4000/api/v1";

export const env = {
  /** Fully-qualified base URL of the REST API, including the `/api/v1` prefix. */
  apiBaseUrl: (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(
    /\/$/,
    "",
  ),
  /** Origin of the API used to resolve relative asset URLs (e.g. uploaded images). */
  get apiOrigin(): string {
    try {
      return new URL(this.apiBaseUrl).origin;
    } catch {
      return "http://localhost:4000";
    }
  },
  /** Optional Stripe publishable key for the client-side payment flow. */
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
  /** Default ISO currency code used for money formatting. */
  currency: process.env.REACT_APP_CURRENCY || "PKR",
  isProduction: process.env.NODE_ENV === "production",
} as const;

/** Resolve a (possibly relative) asset path returned by the API to an absolute URL. */
export function resolveAssetUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;
  return `${env.apiOrigin}${path.startsWith("/") ? "" : "/"}${path}`;
}
